<template lang="pug">
  header
    .header-heading(v-if="!isMobile")
      h2 Vai uma #[strong revisão] hoje?
    .revision-heading
      span + de 3k revisões
      h4 Agende a sua #[strong revisão]
    .schedule-revision
      .schedule-revision__content
        form
          .input-group
            label(for="name") Nome
            input(type="text", id="name", placeholder="Ex: João Silva")
          .input-group
            label(for="date") Data
            datetime(id="date")
          .input-group
            input(type="submit")
</template>

<script>
export default {
  name: 'RHeader',
  data: () => ({
    isMobile: false
  }),
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    this.handleResize()
  },
  methods: {
    handleResize() {
      let windowWidth = window.innerWidth
      if (windowWidth < 1366) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    }
  }
}
</script>

<style lang="stylus">
@import '../assets/css/resources'

header
  position relative
  float left
  display flex
  flex-direction column
  justify-content flex-end
  align-items center
  width 100%
  height 100%
  background-image url('../assets/images/image1.jpg')
  background-repeat no-repeat
  background-size cover
  background-position center

  &:before
    content ''
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background linear-gradient(to bottom, rgba(black, .7), rgba(#555555, 0))

  .header-heading
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    display flex
    justify-content center
    align-items center

    h2, strong
      font-size 80px
      font-weight 600
      color white

    strong
      font-weight 700
      color $revisacar-red

  .revision-heading
    position relative
    z-index 1
    width 1000px
    display flex
    flex-direction column
    align-items flex-start

    span, h4
      color white
      margin 0

    span
      float left
      font-family 'Poppins', sans-serif
      font-size 13px
      font-weight 600
      letter-spacing 2.5px
      text-transform uppercase

    h4
      font-size 35px
      font-weight 300
      margin-bottom 25px

      strong
        font-weight 700
        color $revisacar-red

    &:before
      content ''
      position absolute
      bottom 0
      width 50px
      height 3px
      background-color $revisacar-red

  .schedule-revision
    display flex
    z-index 1
    justify-content center
    width 100%
    height 160px
    background linear-gradient(to bottom, rgba(black, .2), rgba(black, 1))

    .schedule-revision__content
      width 1000px
      height 100%

      form
        width 100%
        height 100%
        display flex
        justify-content space-between
        align-items center
        align-items center

        .input-group
          flex 1 0 auto
          height 100px
          margin-right 20px
          display flex
          flex-direction column
          justify-content flex-end
          align-items flex-start

          &:last-child
            margin 0

          label
            color white
            font-family 'Poppins', sans-serif
            font-size 13px
            margin-bottom 10px
            font-weight 700
            letter-spacing 2.5px
            text-transform uppercase

          .vdatetime
            width 100%

          input
            width 100%
            padding 20px 25px
            border-radius 6px
            border 0
            outline 0
            box-sizing border-box
            color #555555
            font-family 'Poppins', sans-serif
            font-size 14px
            font-weight 700
            letter-spacing 2.5px

            &[type="submit"]
              text-transform uppercase
              background-color $revisacar-red
              color white

@media (max-width: 1366px)
  header
    height 100%

    .header-heading

      h2, strong
        font-size 50px
        text-align center

    .revision-heading
      width 100%
      padding 0 10px
      box-sizing border-box

      span
        float left
        font-family 'Poppins', sans-serif
        font-size 13px
        font-weight 600
        letter-spacing 2.5px
        text-transform uppercase

      h4
        font-size 35px
        font-weight 300
        margin-bottom 25px
        text-align left

        strong
          font-weight 700
          color $revisacar-red

      &:before
        content ''
        position absolute
        bottom 0
        width 50px
        height 3px
        background-color $revisacar-red

    .schedule-revision
      display flex
      z-index 1
      justify-content center
      width 100%
      height auto
      background linear-gradient(to bottom, rgba(black, .2), rgba(black, 1))

      .schedule-revision__content
        width 1000px
        height 100%
        padding 20px 0

        form
          width 100%
          height 100%
          display flex
          flex-direction column
          justify-content space-between
          align-items center
          align-items center

          .input-group
            height 100px
            flex none
            width 100%
            padding 0 20px
            box-sizing border-box
            margin 0

            &:last-child
              margin 0

            label
              color white
              font-family 'Poppins', sans-serif
              font-size 13px
              margin-bottom 10px
              font-weight 700
              letter-spacing 2.5px
              text-transform uppercase

            .vdatetime
              width 100%

            input
              width 100%
              padding 20px 25px
              border-radius 6px
              border 0
              outline 0
              box-sizing border-box
              color #555555
              font-family 'Poppins', sans-serif
              font-size 14px
              font-weight 700
              letter-spacing 2.5px

              &[type="submit"]
                text-transform uppercase
                background-color $revisacar-red
                color white
</style>



// WEBPACK FOOTER //
// src/components/RHeader.vue